module.exports = __webpack_public_path__ + "img/新闻资讯_04.e16c3478.png";